import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Container, Form, Button, Row, Col, Collapse } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import l10n from 'localization/LocalizationData';
import { codePattern } from 'helpers/InputValidation';
import { MainLayout } from 'components/layouts/MainLayout';
import { CheckQueryParamSettings, GetQueryCulture } from 'Utilities/QueryParamSettings';
import { ParseStringToHTML } from 'Utilities/StringParser';


export const HomePage = (props: RouteComponentProps<{}>) => {
	const [validated, setValidated] = React.useState(false);
	const [showResultInput, setShowResultInput] = React.useState(false);

	CheckQueryParamSettings(props.location.search);

	if (CheckQueryParamSettings(props.location.search)) {
		const queryCulture = GetQueryCulture();
		if (queryCulture) {
			l10n.setLanguage(queryCulture);
		}
	}


	function onCodeSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();

		const form = e.currentTarget;
		const valid = form.checkValidity();

		if (valid === true) {
			setValidated(false);
			props.history.push(`/result/${form.resultcode.value}`);
		} else {
			setValidated(true);
		}

	}

	return (
		<MainLayout header={
			<a className='survey-btn' href='https://link.webropolsurveys.com/S/7880410DFA22C2D8' target='_blank' rel='noopener noreferrer'>
				<Button className='no-print'>{l10n.resultSharing_survey}</Button>
			</a>
		}>
			<Container>
				<h1 className='title'>{l10n.home_title}</h1>
				<Row className='mb-4'><Col className='common-indent'>
					{ParseStringToHTML(l10n.home_description, 'home-welcome')}
					<p><a href='http://hankkeet.kuntoutussaatio.fi/spiral/' target="_blank" rel='noopener noreferrer'><b>{l10n.home_description_link}</b></a></p>
				</Col>
				</Row>

				<Row className='mb-4'>
					<Col xs='auto' className='common-indent'>
						<LinkContainer to='/questionnaire'>
							<Button>{l10n.home_startQuestionnaire_button}</Button>
						</LinkContainer>
					</Col>
				</Row>
				<Row className='mt-5'>
					<Col className='common-indent'>
						<Button className='container-title' aria-expanded={showResultInput} aria-controls='result-code-form' onClick={() => setShowResultInput(!showResultInput)}>{l10n.home_resultOpener_button}</Button>
						<Collapse in={showResultInput}>
							<div id='result-code-form' className='result-code-drawer'>
								<Form onSubmit={onCodeSubmit} className='mt-2' validated={validated} noValidate>
									<Form.Group controlId='resultcode'>
										<Form.Label> {l10n.home_resultOpener_title}</Form.Label>
										<Form.Control required type='text' pattern={codePattern} />
										<Form.Control.Feedback type='invalid'>{l10n.home_resultOpener_error_invalidFormat}</Form.Control.Feedback>
									</Form.Group>
									<Button type='submit' className='mb-4'>{l10n.home_resultOpener_submit}</Button>
								</Form>
							</div>

						</Collapse>
					</Col>
				</Row>
			</Container>

		</MainLayout >

	);
}